<template>
    <div>
        <img src="./jqr@2x.png" alt="" class="top-img" />
        <div class="title">请问怎么称呼您</div>
        <br />
        <br />
        <div class="head-portrait">
            <img
                :src="require(`./${gender == MALE ? 'n' : 'v'}@2x.png`)"
                alt=""
            />
        </div>
        <br />
        <br />
        <br />
        <div class="flex-box" style="padding-bottom:.2rem">
            <div class="form-box">
                <input
                    type="text txr-asterisk"
                    :value="name"
                    placeholder="请输入"
                    @input="inputChange"
                />
                <div class="err-tip" v-show="errTip">* {{ errTip }}</div>
            </div>
            <div style="font-size: 0.14rem;">{{ APPELLATION[gender] }}</div>
        </div>
        <br />
        <div class="flex-box next-box">
            <div @click="back">重选性别</div>
            <div
                @click="onClickNext"
                class="btn-next"
                :class="{ gray: !nextPass }"
                sensor-click
            >
                填好了
            </div>
        </div>
    </div>
</template>

<script>
import { APPELLATION, MALE } from "../../../../enum/GENDER.js";
import Validator from "cignacmb-validator";
import isChineseName from "cignacmb-validates/src/isChineseName.js";

const validateSchema = {
    type: "object",
    properties: {
        name: {
            type: "string",
            rules: [
                {
                    validate({ value, isNotEmpty }) {
                        return [isNotEmpty(value), "姓名为必填"];
                    },
                },
                {
                    premise: function({ parent }) {
                        return isChineseName(parent.name);
                    },
                    validate({ value }) {
                        const LE = value.length;

                        return [
                            LE <= 10 && LE >= 1,
                            "中文姓名长度不符合要求，请您重新输入",
                        ];
                    },
                },
                {
                    premise: function({ parent }) {
                        return !isChineseName(parent.name);
                    },
                    validate({ value }) {
                        const res = value
                            .split(" ")
                            .findIndex((item) => !/^[a-zA-Z]+$/g.test(item));
                        const LE = value.length;
                        if (res > -1) {
                            return [false, "请正确输入中文或英文"];
                        } else {
                            return [
                                LE <= 32 && LE >= 2,
                                "英文姓名长度不符合要求，请您重新输入",
                            ];
                        }
                    },
                },
            ],
        },
    },
};

export default {
    props: {
        index: Number, // 题目顺序
        updateAnswer: Function, // 更新答案
        next: Function,
        back: Function,
        gender: [String, Number],
        name: String,
    },
    data() {
        this.MALE = MALE;
        this.APPELLATION = APPELLATION;
        this.validator = new Validator(validateSchema);

        return {
            nextPass: false,
            errTip: "",
        };
    },
    mounted() {
        this.name && this.validatorName(this.name);
    },
    methods: {
        inputChange(e) {
            this.updateAnswer(e.target.value);
            this.validatorName(e.target.value);
        },
        onClickNext(e) {
            const text = e.target.innerText;
            console.log(`测评页-第${this.index}题:`, text);
            this.sensorsAdd("BDWebClick", {
                $element_content: text,
                $title: `测评页-第${this.index}题`,
            });

            this.sensorsAdd("BDanswerResult", {
                entrance_location: "",
                question_number: this.index,
                question: `请问怎么称呼您`,
                answer: this.name,
            });

            // 校验通过执行next方法
            this.validatorName(this.name).then((res) => {
                res && this.next();
            });
        },
        validatorName(value) {
            return this.validator
                .run({
                    originData: {
                        name: value || "",
                    },
                    mode: "stop",
                })
                .finally(() => (this.nextPass = false))
                .then(
                    () => {
                        this.nextPass = true;
                        this.errTip = "";
                        return true;
                    },
                    ({ name }) => {
                        this.errTip = name;
                        return false;
                    }
                );
        },
    },
};
</script>

<style scoped>
.top-img {
    margin: 0.2rem 0 0.5rem 0.22rem;
    width: 1rem;
    height: 0.87rem;
}
.title {
    font-size: 0.15rem;
    font-family: PingFang SC;
    font-weight: bold;
    color: #0f2742;
    line-height: 0.19rem;
    text-align: center;
}
.head-portrait {
    margin: 0 auto;
    width: 0.84rem;
    height: 0.84rem;
    position: relative;
}
.head-portrait img {
    width: 0.84rem;
    height: 0.84rem;
}
.head-portrait::before {
    display: block;
    content: "";
    width: 0.21rem;
    height: 0.21rem;
    background: url("./y@2x.png") no-repeat;
    background-size: cover;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%) translateY(50%);
}
.flex-box {
    display: flex;
    justify-content: center;
    align-items: center;
}
.form-box {
    display: inline-block;
    position: relative;
}

input {
    width: 1.74rem;
    font-size: 0.19rem;
    font-family: PingFang SC;
    color: #0f2742;
    line-height: 0.19rem;
    padding: 0.1rem 0;
    background-color: transparent;
    border: 1px solid transparent;
    border-bottom-color: #eeee;
    text-align: center;
}
input:focus {
    outline: none;
}
.err-tip {
    width: 150%;
    text-align: center;
    font-size: 0.12rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #f34747;
    line-height: 0.19rem;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%) translateY(150%);
}

.next-box {
    margin-top: 1.2rem;
    width: 100%;
    justify-content: space-between;
    padding: 0 0.2rem 0.2rem;
    box-sizing: border-box;
    background: transparent;
}
.next-box > div {
    padding: 0.06rem 0.16rem;
    font-size: 0.13rem;
    font-weight: 500;
    color: #bbc3ca;
    line-height: 0.19rem;
}
.next-box > div:nth-child(1) {
    border-radius: 0.15rem;
    border: 1px solid #3b97ff;
    color: #3b97ff;
    background: white;
}
.next-box .btn-next {
    font-size: 0.14rem;
    color: #ffffff;
    background: #3b97ff;
    border-radius: 0.15rem;
}
</style>
